import { ErrorCode } from '../../shared/error-codes';
import { isMultiFrequency } from '../../shared/capacity';
import { ManualCapacityDisplaySchema } from '../../entities/process-step-recording/process-step-recording.schema';
/**
 * PUT /api/v2/process/:processId/draft/steps/:stepId/manual-capacity — request.
 * The three primitives a step survey collects; the server stamps `enteredBy`
 * and `enteredAt` itself.
 *
 * The cross-field rule lives here rather than on the entity schema, which must
 * stay refinement-free (bliksy resolveSubSchema constraint).
 */ export const SetDraftStepManualCapacityRequestSchema = ManualCapacityDisplaySchema.superRefine((value, ctx)=>{
    const expectsCount = isMultiFrequency(value.frequency);
    if (expectsCount && value.frequencyTimesPerPeriod == null) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'frequencyTimesPerPeriod'
            ],
            message: ErrorCode.FIELD_REQUIRED
        });
    }
    if (!expectsCount && value.frequencyTimesPerPeriod != null) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'frequencyTimesPerPeriod'
            ],
            message: ErrorCode.FIELD_INVALID
        });
    }
});

//# sourceMappingURL=set-draft-step-manual-capacity.schema.js.map